// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import fileAttachment01Icon from "@/assets/icons/file-attachment-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type FileAttachment01IconProps = Omit<IconProps, "name">;

export function FileAttachment01Icon(props: FileAttachment01IconProps): React.ReactNode {
  return <Icon name={fileAttachment01Icon} {...props} />;
}
